<div class="wizard">
  <div class="wizard-header">
    <div class="d-flex justify-content-between text-secondary border-bottom">
      <h6 [class.text-primary]="currentTab === 0">
        <span class="badge rounded-circle me-1 align-bottom"
              [class.text-bg-secondary]="currentTab !== 0"
              [class.text-bg-primary]="currentTab === 0">1</span>Notice
      </h6>
      <h6 [class.text-primary]="currentTab === 1">
        <span class="badge rounded-circle me-1 align-bottom"
              [class.text-bg-secondary]="currentTab !== 1"
              [class.text-bg-primary]="currentTab === 1">2</span>Select
      </h6>
      <h6 [class.text-primary]="currentTab === 2">
        <span class="badge rounded-circle me-1 align-bottom"
              [class.text-bg-secondary]="currentTab !== 2"
              [class.text-bg-primary]="currentTab === 2">3</span>Scan QR code
      </h6>
    </div>
  </div>
  <div class="wizard-content py-3">
    @if (currentTab === 0) {
    <div>
      <p>This will manually add a device to the MDM.</p>
      <p>
        <span class="text-danger text-bold">DON'T USE: </span>if your device is in DEP; it should show up in the
        unassigned device.
      </p>
    </div>
    } @else if (currentTab === 1) {
    <div>
      <p>
        Select the way you want to link the device. To a specific location as a spare or as a device assigned to a
        room. If you don't know yet, click
        <button class="btn btn-link p-0 align-baseline"
                (click)="nextWithoutSelection()">here</button>.
      </p>
      <era-device-link-selector [selection]="selection"></era-device-link-selector>
    </div>
    } @else if (currentTab === 2) {
    <div class="h-100">
      <era-pairing-code [brandId]="selection?.brandId"
                        [locationId]="selection?.locationId"
                        [roomId]="selection?.roomId"></era-pairing-code>
    </div>
    }
  </div>
  <div class="wizard-buttons d-flex justify-content-between border-top pt-1">
    <button [class.invisible]="currentTab === 0"
            class="btn btn-outline-primary"
            (click)="previous()">Previous</button>
    <button [class.invisible]="currentTab === 2"
            class="btn btn-primary"
            [disabled]="!allowNext"
            (click)="next()">
      Next
    </button>
  </div>
</div>